import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import TransactionsGridCard from "./TransactionsGridCard";

export default function TransactionsGrid({
  rows,
  accLoading,
  showEmptyState,
}) {
  if (accLoading) {
    return (
      <div className="w-full flex justify-center items-center gap-2">
        <p className="text-[#808080]">در حال بارگذاری</p>
        <TableLoading className="text-[#808080]" />
      </div>
    );
  }

  if (showEmptyState) {
    return (
      <div className="w-full flex justify-center items-center flex-col gap-5">
        <p className="text-zi-text-light dark:text-zi-text-dark text-sm sm:text-base">
          موردی برای نمایش وجود ندارد
        </p>
        <SVG name="noData" classname="w-24 fill-cyan-500" />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-4">
      {rows.map((row) => (
        <TransactionsGridCard key={row.uuid} {...row} />
      ))}
    </div>
  );
}
